module.exports = __webpack_public_path__ + "static/img/hni_banner_thumb.4a729ca.webp";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/hni_banner_thumb.webp
// module id = OCb0
// module chunks = 27 28